import { render, staticRenderFns } from "./BranchImport.vue?vue&type=template&id=c2737a90&scoped=true"
import script from "./BranchImport.vue?vue&type=script&lang=js"
export * from "./BranchImport.vue?vue&type=script&lang=js"
import style0 from "./BranchImport.vue?vue&type=style&index=0&id=c2737a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2737a90",
  null
  
)

export default component.exports